@if(imagePath != null) {
  <div class="c-survey__section c-splash-screen is-dialog-image">
    <div class="image">
       <img src={{imagePath}} id="engagementCardImage" />
       <!-- style="max-height: 380px;" -->
    </div>
  </div>
}
<div [ngClass]="[imagePath == null ? 'is-dialog-no-img' : '', dialogObj.SplashScreen != null && imagePath != null ? 'u-padding-top' : '', dialogObj.SplashScreen != null ? 'c-survey__section c-splash-screen is-dialog-content' : 'c-survey__section c-survey__question']">
  @if(dialogObj?.Title != '') {
    @if(surveyData?.surveyId === 'repap-v1') {
      <h5 id="dialogCardHeader" [innerHTML]="dialogObj?.Title | translate"></h5>
    } @else {
      <h5 id="dialogCardHeader">{{dialogObj?.Title | translate}}</h5>
    }
  }
  <div id="dialogCardDescription" [innerHTML]="sanitizedDescription"></div>

  @if (dialogObj?.Template === 'TherapyRecommendation') {
    <app-survey-recommendation class="c-survey__top recommendationMetric" [questionDetails]="dialogObj" [surveyData]="surveyData" (answerSelectedEvent)="answerSelected($event)"></app-survey-recommendation>
  }
</div>
